import { render, staticRenderFns } from "./gameMg.vue?vue&type=template&id=14a2f576&scoped=true&"
import script from "./gameMg.vue?vue&type=script&lang=js&"
export * from "./gameMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2f576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a2f576')) {
      api.createRecord('14a2f576', component.options)
    } else {
      api.reload('14a2f576', component.options)
    }
    module.hot.accept("./gameMg.vue?vue&type=template&id=14a2f576&scoped=true&", function () {
      api.rerender('14a2f576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/configuration/gameMg.vue"
export default component.exports